if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"on_boarding_0_1_0","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(1((65|75|94)8|053|47|504|535|629|714)|3(149|201|732|885)|4(8(14|81|93)|070|539|626|929)|6(197|293|903)|7(256|584|830)|(81|97)22|2745|849)$/.test(chunkId)},
		rootOutputDir: "../../",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}